import axios from 'axios';
import { getApiUrl, API_TIMEOUT, DEFAULT_HEADERS, STORAGE_KEYS, HTTP_STATUS } from '../config/apiConfig';
import ErrorStore from '../contexts/ErrorStore';

const api = axios.create({
  baseURL: getApiUrl(),
  timeout: API_TIMEOUT,
  headers: DEFAULT_HEADERS,
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const appToken = localStorage.getItem(STORAGE_KEYS.TOKEN);
    const adminToken = localStorage.getItem(STORAGE_KEYS.ADMIN_TOKEN);
    const vendorToken = localStorage.getItem('vendorToken');
    const isVendorRequest =
      config.url?.includes('/vendor-dashboard') ||
      config.url?.includes('/vendor-auth') ||
      config.url?.includes('/vendors/profile') ||
      config.url?.includes('/chat');

    // const token = isVendorRequest ? (vendorToken || appToken || adminToken) : appToken;
    const token = isVendorRequest ? (vendorToken || appToken || adminToken) : (appToken || adminToken);


    // console.log("tokens", appToken, vendorToken, adminToken)

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === HTTP_STATUS.UNAUTHORIZED) {
      const requestUrl = error.config?.url || '';
      const isVendorRequest =
        requestUrl.includes('/vendor-dashboard') ||
        requestUrl.includes('/vendor-auth') ||
        requestUrl.includes('/vendors/profile') ||
        requestUrl.includes('/chat');

      if (isVendorRequest) {
        localStorage.removeItem('vendorToken');
        localStorage.removeItem('vendorInfo');
        localStorage.removeItem('userType');
        window.location.href = '/vendor/login';
      } else {
        localStorage.removeItem(STORAGE_KEYS.TOKEN);

        const message = error.response?.data?.error

        ErrorStore.getState().showError(message);
        // window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
